<div class="choose-a-lab-container px-0 pt-4 pb-6 main container">
  @if (showPaymentForm) {
    <div class="container pt-5">
      <ngx-payment-form
        #ngxPaymentForm
        class="payment-form"
        [layout]="orderPaymentFormLayout"
        [totalAmount]="inHomeCollectionCostInCents / 100"
        (paymentsSelected)="onPaymentsSelected($event)"
      ></ngx-payment-form>
      <app-payment-submit-button
        #submitButton
        class="is-block mt-4 mb-5"
        [processing]="processing"
        [payments]="payments"
        [(submissionErrors)]="submissionErrors"
        (paymentSubmitted)="onPaymentSubmit()"
      ></app-payment-submit-button>
    </div>
  } @else {
    @if (!labUpdated) {
      <div class="container pt-5">
        <div class="columns mx-0">
          <div class="column">
            <div class="has-text-centered">
              <h2 class="mb-5">Select a <span class="accent-text">Lab</span></h2>
            </div>
            <div class="info-section mb-5 p-4">
              A lab test is required before a physician can prescribe treatment. This panel measures your testosterone
              levels and key health markers to ensure treatment is safe and appropriate. We cover the cost to help you
              get started faster.
              <ul class="pt-4 pl-4">
                <li>Includes: Total Testosterone, LH, Hemoglobin & Hematocrit, ALT, AST</li>
                <li>No payment required at the lab</li>
                <li>No appointment needed & most visits take about 10 minutes</li>
                <li>Results are typically available within 24-48 hours</li>
              </ul>
            </div>
            <app-test-center
              [showHeader]="false"
              [showSelectedCenter]="false"
              [reEnableButtons]="!!updateError"
              [inHomeCollection]="inHomeCollectionAllowed"
              [tests]="tests"
              (inHomeCollectionStatusChange)="inHomeCollectionUpdate()"
            ></app-test-center>
          </div>
        </div>
        @if (updateError) {
          <div class="columns mx-0">
            <div class="column">
              <app-error-notification classes="has-text-centered" data-qa-id="Update Lab Error Notification">
                {{ updateError }}
              </app-error-notification>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="pt-5 container">
        <div class="card">
          <div class="card-inner-container">
            <div class="is-flex is-flex-direction-column is-align-items-center">
              <img class="card-image" alt="success image" src="assets/img/check-pink.svg" data-qa-id="Card Image" />
              <div class="card-title" data-qa-id="Card Title">Lab Location Confirmed!</div>
              <div class="mt-5 left-align-text">
                @if (isInHomeCollection) {
                  <div>
                    <p class="mt-4">Thank you for choosing In Home Collection.</p>
                  </div>
                } @else {
                  <div>
                    <p class="mt-4">Thank you for selecting your lab location.</p>
                    <p class="mt-4">
                      Your lab requisition has been sent to your email. Please bring it with you (printed or on your
                      phone) when you visit the lab.
                    </p>
                  </div>
                }
                <p class="mt-4">
                  Once your results are ready, our medical team will review them and notify you about the next steps.
                </p>
                <p class="mt-4">
                  If you have any questions, contact us at
                  <a href="mailto:{{ contactEmail }}" class="accent-text" data-qa-id="Contact Email">{{
                    contactEmail
                  }}</a>
                  or message us directly in your account.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  }
</div>
